module.exports = __webpack_public_path__ + "img/Table.eddde520.svg";